import type { InventoryStatus } from '../types/inventoryDetail.types';

const statusMap: Record<InventoryStatus, { label: string; className: string }> = {
 in_stock: { label: 'Còn hàng', className: 'bg-emerald-50 text-emerald-600' },
 low_stock: { label: 'Sắp hết', className: 'bg-amber-50 text-amber-600' },
 out_of_stock: { label: 'Hết hàng', className: 'bg-rose-50 text-rose-600' },
 inactive: { label: 'Tạm dừng', className: 'bg-slate-100 text-slate-600' },
};

export function InventoryDetailStatusBadge({ status }: { status: InventoryStatus }) {
 const config = statusMap[status] ?? statusMap.inactive;

 return (
 <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs ${config.className}`}>
 {config.label}
 </span>
 );
}



